import { useMutation } from "react-query";

import { Endpoints } from "../../enums/Endpoints";
import { QueryParams } from "../../enums/QueryParams";
import { smartbizUrl } from "../ApiClient";
import { IStoreConfigPayload, IStoreConfigurationResponse  } from "../../types/StoreConfig.types";

const { STORES, SUFFIX_CONFIG } = Endpoints;
const { STORE_CONFIG_KEY } = QueryParams;

const useStoreConfigMutation = () => {
  return useMutation<IStoreConfigurationResponse, Error, IStoreConfigPayload>({
    mutationKey: [STORE_CONFIG_KEY],
    mutationFn: (storeConfigPayload: IStoreConfigPayload) =>
      storeConfigMutation(storeConfigPayload),
  });
};

export const storeConfigMutation = async (
  storeConfigPayload: IStoreConfigPayload
): Promise<IStoreConfigurationResponse> => {
  const shopId = localStorage.getItem("shopId");
  const response = (
    await smartbizUrl.post(
      `${STORES}/${shopId}/${SUFFIX_CONFIG}`,
      storeConfigPayload
    )
  )?.data;
  return response;
};

export default useStoreConfigMutation;
